import SpotifyPlaylistVisualPreviewContent from '@cohort/components-xps/components/contents/apps/spotify/playlist/VisualPreviewContent';
import type {SpotifyPlaylistMediaStruct} from '@cohort/shared/apps/spotify/medias/playlist';
import type {VisualPreviewProps} from '@cohort/wallet/apps/Media';

const SpotifyPlaylistVisualPreview: React.FC<VisualPreviewProps<SpotifyPlaylistMediaStruct>> = ({
  config,
  title,
  className,
}) => (
  <SpotifyPlaylistVisualPreviewContent
    thumbnailUrl={config.playlistThumbnailUrl}
    title={title}
    className={className}
  />
);

export default SpotifyPlaylistVisualPreview;
